import React from "react";
import "./style.scss";

const InfoIcon = () => {
    return (
        <div className="info__icon">i</div>
    );
};

export default InfoIcon;
